import { Front } from '@/components/Front';
import { LabradorComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';

export const LabradorFront: LabradorComponent = ({ type, meta, descendants, ...props }) => {
  const className = meta.pageType ?? '';

  return <Front descendants={descendants} {...mergeProps({ className }, props)} />;
};
